import {
  SET_GENERAL_INFO,
  SET_BUSINESS_DETAILS,
  SET_VALUATION_INFO,
  SET_DISCLOSURE
} from "./mutations";

const initialState = {
  generalInfo: {
    logo: null,   // will hold a data-URL string
    website: "",
    name: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    dunsNumber: "",
    overview: "",
    industry: "",
    economics: "",
    pNAICS: "",
    pSIC: "",
    pISIC: "",
    sNAICS: "",
    sSIC: "",
    sISIC: ""
  },
  businessDetails: {
    estimatedEmployees: '',
    organizationalForm: '',
    stateOfOrganizationalForm: '',
    retainedBy: {
      contactName: '',
      positionTitle: '',
      contactEmail: '',
      contactPhone: ''
    },
    capTable: []  // each row: { shareholderNames, positionOrTitle, descriptionOfDuties }
  },
  valuationInfo: {
    effectiveDate: '',
    reportDate: '',
    inspectionDate: '',
    yearToDate: '',
    purposeOfValuation: '',
    intendedUser: '',
    subjectInterest: '',
    formOfReport: '',
    typeOfReport: '',
    standardOfValue: '',
    premiseOfValue: '',
    controllingInterest: '',
    marketability: '',
    discountForLackOfControl: '',
    discountForLackOfMarketability: '',
    analystName: '',
    credentials: '',
    title: '',
    businessPrepare: '',
    email: '',
    phone: '',
    resumeNote: '',
  },
  disclosure: {
    typesUsed: [],          // will be initialized by the component
    conflictItems: [],      // likewise
    conflictOneChecked: false,
    conflictTwoChecked: false,
    conflictThreeChecked: false,
    conflictFourChecked: false,
    conflictFiveChecked: false,
    contingencyChecked: false,
    interestChecked: false,
  },
};

const generalDataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_GENERAL_INFO:
      return {
        ...state,
        generalInfo: payload,
      };

    case SET_BUSINESS_DETAILS:
      return {
        ...state,
        businessDetails: payload,
      };

    case SET_VALUATION_INFO:
      return {
        ...state,
        valuationInfo: payload,
      };

    case SET_DISCLOSURE:
      return {
        ...state,
        disclosure: payload,
      };

    default:
      return state;
  }
};

export default generalDataReducer;
